import { render, staticRenderFns } from "./ExpensesStaffBox.vue?vue&type=template&id=59356c2a&"
import script from "./ExpensesStaffBox.vue?vue&type=script&lang=js&"
export * from "./ExpensesStaffBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports